import { render, staticRenderFns } from "./BaseData.vue?vue&type=template&id=7777c7b0&"
import script from "./BaseData.vue?vue&type=script&lang=js&"
export * from "./BaseData.vue?vue&type=script&lang=js&"
import style0 from "./BaseData.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports